import { normalizeImage } from '@/lib/adapters/image.adapter'
import type {
  BlocklistFormSerializedDataType,
  BlocklistFormType,
  BlockListItemType,
  BlocklistServerItemType,
} from '@/lib/types/blocklist.types'
import { TargetItemEnum } from '@/lib/types/common.types'

export const serializeBlocklistFormData = (
  data: BlocklistFormType,
): BlocklistFormSerializedDataType => {
  const users = data.targets
    .filter((target) => target.type === TargetItemEnum.User)
    .map((target) => ({
      id: target.id,
      validate_clicks: data.blockFutureRevenue,
    }))
  const user_tag_ids = data.targets
    .filter((target) => target.type === TargetItemEnum.UserTag)
    .map((target) => target.id)
  const clients = data.targets
    .filter((target) => target.type === TargetItemEnum.Client)
    .map((target) => target.id)

  return {
    ...(user_tag_ids.length > 0 && { user_tag_ids }),
    ...(clients.length > 0 && { client_ids: clients }),
    ...(users.length > 0 && { users }),
  } as BlocklistFormSerializedDataType
}

export const normalizeBlocklist = (data: BlocklistServerItemType[]): BlockListItemType[] => {
  return data.map((item) => {
    return {
      id: item.id,
      createdAt: item.created_at,
      createdBy: item.created_by
        ? {
            id: item.created_by.id,
            username: item.created_by.username,
            email: item.created_by.email,
            clientId: item.created_by.client_id,
          }
        : undefined,
      userTag: item.user_tag
        ? {
            id: item.user_tag.id,
            name: item.user_tag.name,
            slug: item.user_tag.slug,
            accessLevel: item.user_tag.access_level,
            storeId: item.user_tag.store_id,
          }
        : undefined,
      user: item.user
        ? {
            id: item.user.id,
            username: item.user.username,
            email: item.user.email,
            clientId: item.user.client_id,
            ...(item.user.image && { image: normalizeImage(item.user.image) }),
          }
        : undefined,
      client: item.client
        ? {
            id: item.client.id,
            name: item.client.name,
            revenueShare: item.client.revenue_share,
            clientId: item.client.client_id,
            hasOwnPaymentSystem: item.client.has_own_payment_system,
          }
        : undefined,
      validateClicks: item.validate_clicks,
    }
  })
}
